import { matchingFlags } from "../../context/featureFlags/featureFlagsContext";
import appConfig from "../../feature.config";
import tenantConfig from "../../tenant.config";
import { getMatchingRoute } from "../helper/getMatchingRoute";
import {
  COUNTRY_FLAGGED_PAGES,
  FEATURE_FLAGGED_PAGES,
} from "./featureFlags.constant";

/*
 * This function checks if the feature flagged page is allowed to be displayed.
 * A feature flagged page is allowed to be displayed if
 * - one of the feature flags is active, and one of country is allowed (if country flags are present)
 */
export const isFeatureFlagPageAllowed = (
  pathname: string,
  country?: string
) => {
  const route = getMatchingRoute(pathname, Object.keys(FEATURE_FLAGGED_PAGES));
  const featureFlags = FEATURE_FLAGGED_PAGES[route];
  const countryFlags = COUNTRY_FLAGGED_PAGES[route];
  if (!featureFlags) {
    console.warn(
      `[MIDDLEWARE] No feature flags found for this page ${pathname}.`
    );
    // return false by default if the feature flagged page has no feature flags
    return false;
  }
  if (!countryFlags) return featureFlags.some((flag) => flag);
  return (
    featureFlags.some((flag) => flag) && countryFlags.includes(country || "")
  );
};

export function isProd() {
  const ENVIRONMENT_NAME = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME ?? "";
  return [
    "main",
    "pre-main",
    // "staging",
    "tenant-dicree-pre-main",
    "tenant-dicree-main",
  ].includes(ENVIRONMENT_NAME);
}

export function featureFlag(feature: keyof typeof appConfig) {
  if (isProd()) {
    // Production
    const map = new Map(
      Object.entries({
        ...tenantConfig.services["a-prime"].features,
        ...tenantConfig.services["a-prime"].integrations,
      })
    );
    return (appConfig[feature]?.prod && map.get(feature)?.enabled) || false;
  }

  // Development
  return appConfig[feature]?.dev;
}
